import Vue from 'vue'
import { router } from './_helpers'
import { store } from './_store'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import GetTextPlugin from 'vue-gettext'
import translations from '../translations.json'

import App from './app/App.vue'


Vue.use(Buefy)
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'American English',
    sv_SE: 'Svenska',
  },
  translations: translations
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
